import React from "react";
import { Box, CircularProgress } from "@mui/material";

// Generic overlay used across pages during loading.
const LoadingOverlay = ({ open, opacity = 0.5 }) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: `rgba(255, 255, 255, ${opacity})`,
        zIndex: 10,
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default LoadingOverlay;

